import { useState } from "react";
import { Background } from "../../../shared/ui/background";
import { NavBar } from "../../../shared/ui/navbar";
import { TabSliding } from "../../../shared/ui/tab-sliding";
import { Title } from "../../../shared/ui/title";

import "./extras-view.scss";
import { AchievementsPage } from "../achievements";
import { BordersPage } from "../borders";
import { useAppSelector } from "../../../hooks/hooks";
import {
  selectLanguage,
  selectTranslations,
} from "../../../shared/data-access/store/general/generalSlice";
import { checkTranslationKey } from "../../../utils/translation";
import useAmbientSound from "../../../utils/hooks/use-ambient-sound";

export function ExtrasView() {
  const [tab, setTab] = useState("achievements");
  const lang = useAppSelector(selectLanguage);
  const translations = useAppSelector(selectTranslations);
  useAmbientSound("home");

  return (
    <div id="store">
      <Background type="home">
        <NavBar hasAvatar></NavBar>
        <Title>
          {checkTranslationKey(translations[lang]?.Extras, "Extras")}
        </Title>
        <div className="tab-area">
          <TabSliding
            tabChange={setTab}
            tab={tab}
            tabOptions={{
              achievements: checkTranslationKey(
                translations[lang]?.Achievements,
                "Achievements"
              ),
              borders: checkTranslationKey(
                translations[lang]?.Borders,
                "Borders"
              ),
            }}
          />
        </div>

        {tab === "achievements" ? <AchievementsPage /> : <BordersPage />}
      </Background>
    </div>
  );
}

export default ExtrasView;
